module.exports = __webpack_public_path__ + "media/game_end_2.8e26f425.mp3";